import { render, staticRenderFns } from "./BaseBreadcrumbs.vue?vue&type=template&id=78728c94&"
import script from "./BaseBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./BaseBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports